// import readXlsxFile from 'read-excel-file';
import React, { Component } from 'react';
import ReactExport from 'react-export-excel';
import { withAuthorization } from '../Session';
import { Container, Row, Col, Button } from 'react-bootstrap';
import 'date-fns';
import Spinner from 'react-bootstrap/Spinner';
import * as ROUTES from '../../constants/routes';

import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import OrdersList from './OrdersList';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Summary extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            showOrders: false,
            alert: 0,
            TotalStoreTags: 0,
            TotalEarning: 0,
            TotalOrder: 0,
            alertMessage: '',
            flag: false,
            flag1: false,
            flag2: false,
            showLoading: true,
            storedata: [],
            storeTag: '',
            sheetsFlag: 0,
            step1RevStore: 0,
            step2RevStore: 0,
            step3RevStore: 0,
            step4RevStore: 0,
            selectedTab: '',
            uploadSpinner: false,
            fromDate: this.getFormattedDate('firstDay'),
            toDate: this.getFormattedDate('lastDay'),
            storeSheetdata: ['Fee_Orders'],
            lastUpdatedOrders: '',
            step1Tags: [],
            step2Tags: [],
            step3Tags: [],
            step4Tags: [],
            downlaodstep1Tags: [],
            downlaodstep2Tags: [],
            downlaodstep3Tags: [],
            downlaodstep4Tags: []
        };
    }

    getFormattedDate(dateType) {
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        if (dateType == 'firstDay') {
            var firstDay = new Date(y, m, 1);
        } else {
            var firstDay = new Date(y, m + 1, 0);
        }
        var dd = String(firstDay.getDate()).padStart(2, '0');
        var mm = String(firstDay.getMonth() + 1).padStart(2, '0');
        var yyyy = firstDay.getFullYear();

        var newdate = yyyy + '-' + mm + '-' + dd;
        return newdate;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    async loadData() {
        var userRole = this.props.role;
        if (this.props.role === 'Admins') {
            var userRole = 'Admin';
        }
        if (this.props.role === 'Employees') {
            var userRole = 'Employee';
        }
        if (this.props.role === 'Distributors') {
            var userRole = 'Distributor';
        }
        if (this.props.role === 'StoreCP') {
            var userRole = 'StoreCP';
        }
        if (this.props.role === 'StoreOwners') {
            var userRole = 'StoreOwner';
        }

        let bodyData = {
            UniqeID: this.props.user.ProfileUniqeID,
            userRole:userRole,
            showLocked: this.state.showLocked ? this.state.showLocked : false
        };

        await RestServices.getAllStoresEmailMappedWith(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (AllStoreTagsData) => {
                if (AllStoreTagsData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: AllStoreTagsData.error,
                            showLoading: false
                        });
                    }
                } else {
                    if (AllStoreTagsData.length > 0) {
                        if (this._isMounted) {
                            this.setState({
                                TotalStoreTags: AllStoreTagsData.length
                            });
                        }
                        this.fetchStoreStatics(AllStoreTagsData);
                    } else {
                        if (this._isMounted) {
                            this.setState({ showLoading: false });
                        }
                    }
                }
            })

            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    async fetchStoreStatics(AllStoreTagsData) {
        let StoreRev = 0;
        let storeTagsData = [];
        let step1Tags = [];
        let step2Tags = [];
        let step3Tags = [];
        let step4Tags = [];
        let step1RevStore = 0;
        let step2RevStore = 0;
        let step3RevStore = 0;
        let step4RevStore = 0;

        let downloadstep1Tags = [];
        let downloadstep2Tags = [];
        let downloadstep3Tags = [];
        let downloadstep4Tags = [];

        let bodyData = {
            storeTag: AllStoreTagsData
        };
        

        await RestServices.thisMonthlyStoreStatics(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (responseData) => {
               

                if (responseData) {
                    await responseData.forEach(async (storetag) => {
                        storeTagsData.push(storetag);

                        if (storetag.OpsTotal > 0) {
                            if (storetag.OpsTotal > 1000) {
                                if (storetag.OpsTotal > 2000) {
                                    step4Tags.push({
                                        StoreEmail: storetag.StoreEmail,
                                        Tag: storetag.Tag
                                    });
                                    step4RevStore = step4RevStore + 1;
                                } else {
                                    step3Tags.push({
                                        StoreEmail: storetag.StoreEmail,
                                        Tag: storetag.Tag
                                    });
                                    step3RevStore = step3RevStore + 1;
                                }
                            } else {
                                step2Tags.push({
                                    StoreEmail: storetag.StoreEmail,
                                    Tag: storetag.Tag
                                });
                                step2RevStore = step2RevStore + 1;
                            }
                        } else {
                            step1Tags.push({
                                StoreEmail: storetag.StoreEmail,
                                Tag: storetag.Tag
                            });
                            step1RevStore = step1RevStore + 1;
                        }
                    });
                }
            });

        await AllStoreTagsData.forEach(async (storetag) => {
            if (storeTagsData.some((item) => storetag.StoreTag === item.Tag)) {
            } else {
                step1Tags.push({
                    StoreEmail: storetag.StoreEmail,
                    Tag: storetag.StoreTag
                });
                step1RevStore = step1RevStore + 1;
            }
        });

        if (this._isMounted) {
            this.setState({ step1RevStore: step1RevStore });
            this.setState({ step1Tags: step1Tags });

            this.setState({ step2RevStore: step2RevStore });
            this.setState({ step2Tags: step2Tags });

            this.setState({ step3RevStore: step3RevStore });
            this.setState({ step3Tags: step3Tags });

            this.setState({ step4RevStore: step4RevStore });
            this.setState({ step4Tags: step4Tags });
            this.setState({ showLoading: false });
        }
    }

    showstep1 = () => {
        
        if (this._isMounted) {
            this.setState({ showOrders: 1 });
        }
    };
    showstep2 = () => {
        if (this._isMounted) {
            this.setState({ showOrders: 2 });
        }
    };
    showstep3 = () => {
        if (this._isMounted) {
            this.setState({ showOrders: 3 });
        }
    };
    showstep4 = () => {
        
        if (this._isMounted) {
            this.setState({ showOrders: 4 });
        }
    };

    toggleBlockStatus = () => {
        if (this._isMounted) {
            this.setState({
                showOrders: false,
                showStoreTags: false,
                showLocked: !this.state.showLocked
            });
        }
        setTimeout(() => {
            this.loadData();
        }, 500);
    };

    render() {
        return (
            <div>
                {this.state.showLoading && <Spinner animation="border" />}

                {/*<Row>
                    <Button style={{marginLeft:"1rem", marginRight:"1rem"}} variant="primary"  onClick={this.toggleBlockStatus}>
                    Toggle 
                    {this.state.showLocked &&<LockIcon />}
                    {!this.state.showLocked &&<LockOpenIcon />}
                    </Button>
                </Row>
                 <div><hr/></div>*/}

                {this.state.showLoading === false && (
                    <Row className="center_align">
                        <Col>
                            <h6>
                                0 TOV Stores
                                {this.state.step1RevStore > 0 && (
                                    <span>
                                        {' '}
                                        (
                                        {(
                                            (this.state.step1RevStore /
                                                this.state.TotalStoreTags) *
                                            100
                                        ).toFixed(2)}
                                        %)
                                    </span>
                                )}
                                {this.state.step1RevStore === 0 && (
                                    <span> (0%)</span>
                                )}
                            </h6>
                            <h5 className="round_box step1">
                                {this.state.step1RevStore}
                            </h5>
                            {this.state.step1RevStore > 0 && (
                                <div>
                                    <Button
                                        variant="primary"
                                        onClick={this.showstep1}
                                    >
                                        View
                                    </Button>
                                    <ExcelFile
                                        element={
                                            <Button
                                                style={{ marginLeft: '0.5rem' }}
                                                variant="primary"
                                            >
                                                Download
                                            </Button>
                                        }
                                    >
                                        <ExcelSheet
                                            data={this.state.step1Tags}
                                            name="0 TOV Stores "
                                        >
                                            <ExcelColumn
                                                label="Store Tag"
                                                value="Tag"
                                            />
                                            <ExcelColumn
                                                label="Email"
                                                value="StoreEmail"
                                            />
                                        </ExcelSheet>
                                    </ExcelFile>
                                </div>
                            )}
                            {this.state.step1RevStore == 0 && (
                                <Button variant="light" disabled>
                                    View Stores
                                </Button>
                            )}
                        </Col>

                        <Col>
                            <h6>
                                {'<'} 1000 TOV Stores
                                {this.state.step2RevStore > 0 && (
                                    <span>
                                        {' '}
                                        (
                                        {(
                                            (this.state.step2RevStore /
                                                this.state.TotalStoreTags) *
                                            100
                                        ).toFixed(2)}
                                        %)
                                    </span>
                                )}
                                {this.state.step2RevStore === 0 && (
                                    <span> (0%)</span>
                                )}
                            </h6>
                            <h5 className="round_box step2">
                                {this.state.step2RevStore}
                            </h5>
                            {this.state.step2RevStore > 0 && (
                                <div>
                                    <Button
                                        variant="primary"
                                        onClick={this.showstep2}
                                    >
                                        View
                                    </Button>
                                    <ExcelFile
                                        element={
                                            <Button
                                                style={{ marginLeft: '0.5rem' }}
                                                variant="primary"
                                            >
                                                Download
                                            </Button>
                                        }
                                    >
                                        <ExcelSheet
                                            data={this.state.step2Tags}
                                            name="<1000 TOV Stores "
                                        >
                                            <ExcelColumn
                                                label="Store Tag"
                                                value="Tag"
                                            />
                                            <ExcelColumn
                                                label="Email"
                                                value="StoreEmail"
                                            />
                                        </ExcelSheet>
                                    </ExcelFile>
                                </div>
                            )}
                            {this.state.step2RevStore == 0 && (
                                <Button variant="light" disabled>
                                    View Stores
                                </Button>
                            )}
                        </Col>

                        <Col>
                            <h6>
                                {'<'} 2000 TOV Stores
                                {this.state.step3RevStore > 0 && (
                                    <span>
                                        {' '}
                                        (
                                        {(
                                            (this.state.step3RevStore /
                                                this.state.TotalStoreTags) *
                                            100
                                        ).toFixed(2)}
                                        %)
                                    </span>
                                )}
                                {this.state.step3RevStore === 0 && (
                                    <span> (0%)</span>
                                )}
                            </h6>
                            <h5 className="round_box step3">
                                {this.state.step3RevStore}
                            </h5>
                            {this.state.step3RevStore > 0 && (
                                <div>
                                    <Button
                                        variant="primary"
                                        onClick={this.showstep3}
                                    >
                                        View
                                    </Button>
                                    <ExcelFile
                                        element={
                                            <Button
                                                style={{ marginLeft: '0.5rem' }}
                                                variant="primary"
                                            >
                                                Download
                                            </Button>
                                        }
                                    >
                                        <ExcelSheet
                                            data={this.state.step3Tags}
                                            name="<2000 TOV Stores "
                                        >
                                            <ExcelColumn
                                                label="Store Tag"
                                                value="Tag"
                                            />
                                            <ExcelColumn
                                                label="Email"
                                                value="StoreEmail"
                                            />
                                        </ExcelSheet>
                                    </ExcelFile>
                                </div>
                            )}
                            {this.state.step3RevStore == 0 && (
                                <Button variant="light" disabled>
                                    View Stores
                                </Button>
                            )}
                        </Col>

                        <Col>
                            <h6>
                                2000+ TOV Stores
                                {this.state.step4RevStore > 0 && (
                                    <span>
                                        {' '}
                                        (
                                        {(
                                            (this.state.step4RevStore /
                                                this.state.TotalStoreTags) *
                                            100
                                        ).toFixed(2)}
                                        %)
                                    </span>
                                )}
                                {this.state.step4RevStore === 0 && (
                                    <span> (0%)</span>
                                )}
                            </h6>
                            <h5 className="round_box step4">
                                {this.state.step4RevStore}
                            </h5>
                            {this.state.step4RevStore > 0 && (
                                <div>
                                    <Button
                                        variant="primary"
                                        onClick={this.showstep4}
                                    >
                                        View
                                    </Button>
                                    <ExcelFile
                                        name="2000+ TOV Stores"
                                        element={
                                            <Button
                                                style={{ marginLeft: '0.5rem' }}
                                                variant="primary"
                                            >
                                                Download File
                                            </Button>
                                        }
                                    >
                                        <ExcelSheet
                                            data={this.state.step4Tags}
                                            name="2000+ TOV Stores "
                                        >
                                            <ExcelColumn
                                                label="Store Tag"
                                                value="Tag"
                                            />
                                            <ExcelColumn
                                                label="Email"
                                                value="StoreEmail"
                                            />
                                        </ExcelSheet>
                                    </ExcelFile>
                                </div>
                            )}
                            {this.state.step4RevStore == 0 && (
                                <Button variant="light" disabled>
                                    View Stores
                                </Button>
                            )}
                        </Col>
                    </Row>
                )}
                {this.state.showOrders == 1 && (
                    <OrdersList StoreTags={this.state.step1Tags} />
                )}
                {this.state.showOrders == 2 && (
                    <OrdersList StoreTags={this.state.step2Tags} />
                )}
                {this.state.showOrders == 3 && (
                    <OrdersList StoreTags={this.state.step3Tags} />
                )}
                {this.state.showOrders == 4 && (
                    <OrdersList StoreTags={this.state.step4Tags} />
                )}
            </div>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(Summary);
